<template>
    <div :data-picker-name="name">
        <el-date-picker
                v-model="date_at"
                :id="id"
                type="daterange"
                align="right"
                :placeholder="placeholder"
                :picker-options="pickerOptions"
                @change="change"
                >
        </el-date-picker>
    </div>
</template>
<style lang="scss">
    .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
        max-width: 220px !important;
    }

    .el-date-editor {
        position: relative;

        .el-range__close-icon {
            position: absolute;
            top: 0;
            right: 1px;
        }
    }

</style>
<script>
    var moment = require('moment');

    export default {
        props: ['name', 'placeholder'],
        computed: {
            id() {
                return [this.name + '_from', this.name + '_to'];
            }
        },
        data() {
            return {
                table: null,
                date_at: '',
                pickerOptions: {
                    firstDayOfWeek: 1,
                    shortcuts: [{
                        text: 'Last month',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(moment().add(-1, 'month').startOf('month').toDate());
                            end.setTime(moment().add(-1, 'month').endOf('month').toDate());
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'This month',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(moment().startOf('month').toDate());
                            end.setTime(moment().endOf('month').toDate());
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Next month',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(moment().add(1, 'month').startOf('month').toDate());
                            end.setTime(moment().add(1, 'month').endOf('month').toDate());
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            };
        },
        mounted() {
            var vm = this;
            setTimeout(function () {
                let dates = localStorage.getItem(vm.name + '_' + vm.$parent.$data.table.table().node().id + '_' + window.location.href);
                try {
                    dates = JSON.parse(dates);
                } catch (e) {
                    return false;
                }
                if (dates) {
                    let $maxDate = moment(dates.maxDate, 'YYYY-MM-DD').toDate();
                    let $minDate = moment(dates.minDate, 'YYYY-MM-DD').toDate();
                    vm.date_at = [$minDate, $maxDate];
                    // vm.$parent.$data.table.draw(false);
                    vm.change();
                }

            }, 500);
        },
        methods: {
            change() {
                let vm = this;
                // setTimeout(function () {
                let dates = vm.date_at;
                if (dates && dates.length > 0 && dates[0] !== null) {

                    let $maxDate = moment(dates[1]).format('YYYY-MM-DD');
                    let $minDate = moment(dates[0]).format('YYYY-MM-DD');

                    localStorage.setItem(vm.name + '_' + vm.$parent.$data.table.table().node().id + '_' + window.location.href,
                        JSON.stringify({
                            maxDate: $maxDate,
                            minDate: $minDate
                        }));
                } else {
                    localStorage.removeItem(vm.name + '_' + vm.$parent.$data.table.table().node().id + '_' + window.location.href);
                }

                setTimeout(function () {
                    vm.$parent.$data.table.draw(false);
                }, 500);
                // }, 100);

            }
        }
    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/FilterDate.vue